// extracted by mini-css-extract-plugin
module.exports = {"size":"Product_size__11mgU","inner":"Product_inner__1xShj","close":"Product_close__3_QQc"};